import DesktopHeaderNavigation from './DesktopHeaderNavigation.vue';

export default DesktopHeaderNavigation;
